import React from 'react'

const Error404 = () => {
  return (
    <div>
        <h1>
        Pagina no encontrada
        </h1>
       </div>
  )
}

export default Error404